import { ArrowRight, Network, Shield, TrendingUp, Users } from 'lucide-react'
import { ScoreChip } from '../primitives/ScoreChip'
import type { KpiSummary } from '../selectors'
import { KpiStatTile } from './KpiStatTile'

export interface KpiStatRowProps {
  summary: KpiSummary
  biggestClusterLabel?: string | null
  topSuspectsClusterLabel?: string | null
}

export function KpiStatRow({
  summary,
  biggestClusterLabel,
  topSuspectsClusterLabel,
}: KpiStatRowProps) {
  const clustersSecondary = (() => {
    if (summary.biggestCluster == null) return undefined
    return `largest ${summary.biggestCluster.size} entities`
  })()

  const entitiesSecondary = (() => {
    if (summary.clusters === 0) return undefined
    return `across ${summary.clusters} cluster${summary.clusters === 1 ? '' : 's'}`
  })()

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
      <KpiStatTile
        icon={Users}
        label="Entities"
        value={summary.entities}
        secondary={entitiesSecondary}
      />
      <KpiStatTile
        icon={Network}
        label="Clusters"
        value={summary.clusters}
        secondary={biggestClusterLabel ?? clustersSecondary}
      />
      <KpiStatTile
        icon={ArrowRight}
        label="Bridges"
        value={summary.bridges}
        secondary={summary.bridges > 0 ? 'cross-cluster links' : undefined}
      />
      <KpiStatTile
        icon={Shield}
        label="Suspects"
        value={summary.suspects}
        secondary={topSuspectsClusterLabel ?? undefined}
      />
      <KpiStatTile
        icon={TrendingUp}
        label="Top Score"
        value={summary.topScore == null ? null : <ScoreChip value={summary.topScore} size="md" />}
        secondary={summary.topScoreEntityName ?? undefined}
        className="col-span-2 md:col-span-1"
      />
    </div>
  )
}
